<template>
  <div
    :id="props.id"
    :class="DS_EMOJI_PICKER_CLASSES.FastSelect"
    role="dialog"
    :aria-label="props.popupLabel"
    data-cy="ds-emoji-picker__fast-select"
  >
    <DSButton
      v-for="emoji in props.emojis"
      :key="emoji.unicode"
      :variant="DS_BUTTON_VARIANT.Ghost"
      :size="DS_SIZE.Small"
      :aria-label="emoji.aliases[0]"
      :data-cy="`ds-emoji-picker__fast-select-item--${emoji.unicode}`"
      @click="selectEmoji(emoji)"
    >
      {{ emoji.native }}
    </DSButton>

    <DSButton
      :variant="DS_BUTTON_VARIANT.Ghost"
      :size="DS_SIZE.Small"
      prefix-icon="c-add"
      :aria-label="SHOW_ALL_LABEL"
      data-cy="ds-emoji-picker__show-all"
      @click="emit('show-all')"
    />
  </div>
</template>

<script setup lang="ts">
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";
import { DS_BUTTON_VARIANT } from "@/src/design_system/button_and_controls/button/types/props";
import { DS_EMOJI_PICKER_CLASSES } from "@/src/design_system/button_and_controls/emoji_picker/constants/classes";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import type { EmojiDisplayItem, EmojiSelection } from "@/src/shared/emoji/types";

const props = defineProps<{
  id: string;
  popupLabel: string;
  emojis: EmojiDisplayItem[];
}>();

const emit = defineEmits<{
  (e: "select", selection: EmojiSelection): void;
  (e: "show-all"): void;
}>();

const SHOW_ALL_LABEL = window.I18n.designSystem.emojiPicker.showAllLabel;

const selectEmoji = (emoji: EmojiDisplayItem): void => {
  emit("select", { unicode: emoji.unicode, native: emoji.native });
};
</script>
